import { render, staticRenderFns } from "./publish-succeed.vue?vue&type=template&id=086371fe&scoped=true"
import script from "./publish-succeed.vue?vue&type=script&lang=js"
export * from "./publish-succeed.vue?vue&type=script&lang=js"
import style0 from "./publish-succeed.vue?vue&type=style&index=0&id=086371fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086371fe",
  null
  
)

export default component.exports